import { forwardRef, type SVGProps } from 'react';

export const LoadingCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M10 20c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V0C4.579 0 0 4.58 0 10c0 5.421 4.579 10 10 10z"
      fill="currentColor"
    />
  </svg>
));
